<template>
	<div>
		<toast></toast>
        <div v-show="showDetail == 0">
            <div class="nano centre_content">
                <div class="pl-3" v-if="!viewToggle">
                    <i class="fa fa-mortar-board fa-lg mr-2"></i>Consulting Service
                    <span class="myBtn" @click='goback()'>Back</span>
            </div>
            <div class="nano-content p-4">
                <h5 v-if="typey==1" class="information_article_headline">Reporter profile：</h5>
                <h5 v-if="typey==2" class="information_article_headline">Expert profile：</h5>
                <h5 v-if="typey==3" class="information_article_headline">机构简介：</h5>
                <p v-html="description"></p>
                <h5 v-if="typey==1" class="information_article_headline">Investment advice：</h5>
                <h5 v-if="typey==2" class="information_article_headline">Expert column：</h5>
                <h5 v-if="typey==3" class="information_article_headline">最新观点：</h5>
                <p  v-if="typey == 1" v-html="advice"></p>
                <div v-if="spacecontent">
                    <p  v-if="typey == 2 || typey == 3" v-html="spacecontent.title ?spacecontent.title:''" class="consult_article_title"></p>
                    <p v-if="typey == 2 || typey == 3" v-html="spacecontent.content?spacecontent.content:''"></p>
                </div>
            </div>
            </div>
        </div>
        <div v-show="showDetail != 0">
        <div v-if="!this.detailes.is_pay">

		    <div class="centre_content nano">

                <span class="nano-content p-4" >
                    <div class="pl-3" v-if="!viewToggle">
                        <span class="myBtn" @click='goback()'>Back</span>
                    </div>
                    <!--<p class="text-center" v-if="loadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>-->
					<h1 class="information_article_headline">{{this.detailes.title}}</h1>
                    <div class="media-body">
                        <p class="information_article_info" v-if="!detailes.space">
                            <span class="mr-2">{{this.detailes.published}}</span>
                            <span v-if="detailes.author && detailes.author.length > 0">Author：<span class="mr-2" v-for="(value,index) in detailes.author">{{value}}</span>
							</span>
                            <span v-if="this.detailes.source">Sources：{{this.detailes.source}}</span>
                        </p>
                        <div class="particulars_organization_title" v-if="detailes.space">
                                    <span @click="Torouter(space.alias)">
                                        <img :src="space.photo" style="border-radius: 100px;width: 30px;height: 30px;" />
                                    </span>
                                    <span @click="Torouter(space.alias)">{{space.name}}</span>
                                    <span class="organization" v-if="space.typeid == 1" @click="gotoPage(1)">Reporter</span>
                                    <span class="organization" v-if="space.typeid == 2" @click="gotoPage(2)">External expert</span>
                                    <span class="organization" v-if="space.typeid == 3" @click="gotoPage(3)">Institutional research</span>
                                    <span>{{this.detailes.published}}</span>
                        </div>
                    </div>
					<div class="information_article_abstract rounded" v-if="this.detailes.description">
						<p>
							Abstract：{{this.detailes.description}}
						</p>
					</div>
            <!-- 文章 -->
			<div class="information_article_details text-indent2" v-if="this.detailes.appid == 1" v-html="this.detailes.content"></div>
            <!-- 组图 -->
            <div class="information_article_details text-indent2" v-if="this.detailes.appid == 2">
                <div v-for="item in JSON.parse(this.detailes.content)">
                    <p>
                        <img class="img-thumbnail" :src="item.url"/>
                    </p>
                    <p v-html="item.description"></p>
                </div>
            </div>

			<span class="f12 d-block mb-2" v-if="this.detailes.editor">Editor：{{this.detailes.editor}}</span>
			<div class="text-center">
                <div id="qrcode"></div>
				<p class="mt-2 text-center f14 text-secondary">Scan QR-code for mobile service</p>
			</div>
			<div class="pb-4 w-100 border-top-0 border-right-0 border-left-0" style="border: 1px dashed rgba(232,234,239,1);">
				<span class="float-left f12 text-black-50" v-if="this.detailes.keyword && this.detailes.keyword.length > 0">Keywords：</span>
				<span v-for="(value,index) in this.detailes.keyword" class="float-left f12 text-black-50 pl-2 pr-2">
                    <router-link :to="{name: 'searchresult', params :{keyword:value}}" class="antistop">{{value}}</router-link>
					<!--<a :href="'/tags/'+ value" class="antistop" target="_blank">{{value}}</a>-->
				</span>
			</div>
                <div v-if="detailes.attachment&&detailes.attachment.length>0">
                    <a :href="item.url" target="_blank" v-for="(item,index) in detailes.attachment" :key="index"  style="color: #0a75be!important">{{item.alias}}</a>
                </div>
			<div class="w-100 viedo_article_share mt-2 mb-5">
				<!--<div class="float-left">-->
					<!--<img src="../../../../assets/images/silkRoadBase/weixin.png" class="pl-2 pr-2">-->
					<!--<img src="../../../../assets/images/silkRoadBase/everyone.png" class="pl-2 pr-2">-->
					<!--<img src="../../../../assets/images/silkRoadBase/kongjian.png" class="pl-2 pr-2">-->
					<!--<img src="../../../../assets/images/silkRoadBase/Sina_weibo.png" class="pl-2 pr-2">-->
					<!--<img src="../../../../assets/images/silkRoadBase/Tencent_weibo.png" class="pl-2 pr-2">-->
					<!--<img src="../../../../assets/images/silkRoadBase/add_share.png" class="pl-2 pr-2">-->
				<!--</div>-->

        <!--评论start-->
				<div class="float-right">
					<button class="btn btn-outline-secondary rounded-pill f12 mr-3 mybtns" style="border-radius: 50px;" @click="digg()"><i class="fa fa-thumbs-up mr-2"></i>Like<span class="ml-2"></span></button>
					<button class="btn btn-outline-secondary rounded-pill f12 mybtns" style="border-radius: 50px;" @click="like()"><i class="fa fa-star mr-2" @click=""></i>Favorite</button>
				</div>
			</div>
            <div class="M-block"></div>
			<div class="card commentList" v-if="sys_comment">
				<div class="card-body">
				    <div>
				    	<textarea class="p-3 w-100 bg-light f14" v-model="content" placeholder="Say something ..."></textarea>
				    </div>
				    <div class="comment">
				    	<button class="btn f15 pl-3 pr-3" @click="sendComment()">Comments</button>
				    </div>
				</div>
			</div>
            <div class="listTotal" v-if="comment.length > 0 && sys_comment">
            <span class="totalT">All comments</span>
            <span class="totalNum">{{comment_total}}</span>
            </div>
            <ul class="lists" v-if="comment.length > 0 && sys_comment">
            <li v-for="item in comment">
                <img :src="item.passport.img_url ? item.passport.img_url : '../../../../assets/images/silkRoadBase/images/nohead.png'" alt="" />
                <div>
                    <p><span>{{item.passport.nickname}}</span><span>{{timeDiff(item.create_time)}}</span></p>
                    <p>{{item.content}}</p>
                </div>
            </li>
            </ul>
                    <!--畅言-->
            <div id="SOHUCS" v-show="cy_comment"></div>
            <!--评论结束end-->
			</span>
		</div>
        </div>
        <div v-if="this.detailes.is_pay">
        <div class="nano centre_content charge_hint">
            <div class="centre_content nano-content p-4">
                <h1 class="information_article_headline">{{this.detailes.title}}</h1>
                <div class="media-body">
                    <p class="information_article_info" v-if="!detailes.space">
                        <span class="mr-2">{{this.detailes.published}}</span>
                        <span v-if="detailes.author && detailes.author.length > 0">Author：<span class="mr-2" v-for="(value,index) in detailes.author">{{value}}</span>
							</span>
                        <span v-if="this.detailes.source">Sources：{{this.detailes.source}}</span>
                    </p>
                    <div class="particulars_organization_title">
                            <span @click="Torouter(space.alias)">
                                <img :src="space.photo" style="border-radius: 100px;width: 30px;height: 30px;" />
                            </span>
                            <span @click="Torouter(space.alias)">{{space.name}}</span>
                            <span class="organization" v-if="space.typeid == 1" @click="gotoPage(1)">Reporter</span>
                            <span class="organization" v-if="space.typeid == 2" @click="gotoPage(2)">External expert</span>
                            <span class="organization" v-if="space.typeid == 3" @click="gotoPage(3)">Institutional research</span>
                            <span>{{detailes.published}}</span>
                    </div>
                </div>
                <div class="information_article_abstract rounded" v-if="this.detailes.description">
                    <p>
                        Abstract：{{this.detailes.description}}
                    </p>
                </div>
                <div class="card text-center p-3 pb-0">
                    <div class="card-body p-0 mycard">
                        <!--<NoPay :obj="detailes"></NoPay>-->
                        <h5 class="mt-3 mb-3 ">
                            <img src="../../../../assets/images/silkRoadBase/member.png" class="mr-2" />
                            VIP exclusive
                        </h5>
                        <h4 class="f20 fn600">Paid subscription</h4>
                        <p class="card-text f15 text-secondary mt-3 mb-3">Buy a VIP membership to enjoy exclusive service of Xinhua Silk Road</p>
                        <a href="/db#/accountSettings/menberCenter" class="btn btn-warning mt-3 text-white">Buy now</a>
                        <p class="mt-5 mb-5">More VIP privileges</p>
                        <div class="d-flex row justify-content-around m-0">
                            <div class="card col-md-4 col-12 p-0">
                                <div class="card-body">
                                    <img src="../../../../assets/images/silkRoadBase/56878730129766812.png" />
                                    <h5 class="card-title mt-3 mb-3">Analyst service</h5>
                                    <h6 class="card-subtitle mb-2 text-muted">180 overseas branches of Xinhua News Agency, and chief reporters' observations and interaction with them</h6>
                                </div>
                            </div>
                            <div class="card col-md-4 col-12 p-0">
                                <div class="card-body">
                                    <img src="../../../../assets/images/silkRoadBase/41408370476170076.png" />
                                    <h5 class="card-title mt-3 mb-3">Consulting service</h5>
                                    <h6 class="card-subtitle mb-2 text-muted">Research trends and achievements of more than 100 top think tanks and consulting institutions in the world</h6>
                                </div>
                            </div>
                            <div class="card col-md-4 col-12 p-0">
                                <div class="card-body">
                                    <img src="../../../../assets/images/silkRoadBase/507574572099684577.png" />
                                    <h5 class="card-title mt-3 mb-3">Overseas activities service</h5>
                                    <h6 class="card-subtitle mb-2 text-muted">Latest information inquiry and release of investment projects home and abroad</h6>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


                <div class="modal fade" id="buyModal">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">Payment</h4>
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                            </div>

                            <!-- 模态框主体 -->
                            <div class="modal-body">
                                <div class="card border-bottom">
                                    <div class="card-body">
                                        <div class="d-flex w-100 abc" style="">
                                            <div class="">
                                                <img :src="this.detailes.thumb"  v-if="this.detailes.thumb" class="img-fluid" style="width: 135px; height: 100px;" />
                                            </div>
                                            <div class="flex-grow-1 ml-3">
                                                <p class="f15 pb-2 myfont">{{this.detailes.title}}</p>
                                                <p class="desp">{{this.detailes.description}}</p>
                                                <div class="">
                                                    <p class="f14 float-left mb-0 text-black-50">Purchase a single article</p>
                                                    <p class="f22 float-right mb-0 text-secondary mcur">Amount：{{this.detailes.price}} USD</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-body">
                                        <div class="w-100">
                                            <div class="text-center mb-2">

                                                <button @click="checkpays('wechat')" :class="{checkpay:checkpay=='wechat'}" type="button" class="btn f16 mr-5 mybtn">
                                                <img src="../../../../assets/images/silkRoadBase/weixinPay.png" class="img-fluid mr-2" style="width: 20px; height: 20px;" />WeChat Pay
                                                </button>
                                                <button @click="checkpays('alipay')" :class="{checkpay:checkpay=='alipay'}" type="button" class="btn f16 mybtn cur">
                                                <img src="../../../../assets/images/silkRoadBase/zhifubaoPay.png" class="img-fluid mr-2" style="width: 20px; height: 20px;" />Alipay
                                                </button>
                                            </div>
                                            <div class="text-center" v-show="checkpay==='wechat'">
                                                <!--<div class="text-center">-->
                                                    <div id="payQrcode" style="width:150px;height: 150px;margin: 5px auto;"></div>
                                                <!--</div>-->
                                                <p class="f16">
                                                    <img src="../../../../assets/images/silkRoadBase/weixinPay.png" class="img-fluid mr-2" style="width: 20px; height: 20px;" /> WeChat Pay,{{this.detailes.price}} USD

                                                </p>
                                            </div>
                                            <div class="text-center" v-show="checkpay==='alipay'">
                                                <p>
                                                    <!--<img src="../../../../assets/images/silkRoadBase/二维码.gif" class="img-fluid" />-->
                                                </p>
                                                <p class="f16">

                                                    <img src="../../../../assets/images/silkRoadBase/zhifubaoPay.png" class="img-fluid mr-2" style="width: 20px; height: 20px;" /> Alipay,{{this.detailes.price}} USD
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="d-inline-block w-100 pl-3 pr-3 mt-2 myfix" style="line-height: 70px;box-shadow:0px 0px 5px 0px rgba(0,0,0,0.05);">
                <span class="" style="display:block;height:40px;font-size:14px;font-family:PingFangSC-Regular;font-weight:600;color:rgba(0,0,0,1);line-height:40px;border-bottom:1px solid #F5F6F7">Or you can purchase a single article</span>
                <div class="float-left">
                    <img :src="this.detailes.thumb" v-if="this.detailes.thumb" class="img-fluid" style="width: 60px; height: 45px;" />
                </div>
                <div class="float-left ml-3">
                    <p class="f14 mb-0 titleBreviary pb-2 w-75" style="line-height: 40px;">{{this.detailes.title}}</p>
                    <p class="f12 mb-0 text-black-50" style="line-height: 25px;">Purchase a single article</p>
                </div>
                <div class="float-right ml-3">
                    <div>
                        <button class="btn btn-primary f15" data-toggle="modal" data-target="#buyModal" @click="checkpays('wechat')">Purchase a single article</button>
                    </div>
                </div>
                <div class="float-right">
                    <p class="f15">Amount：{{this.detailes.price}} USD</p>
                </div>
            </div>
        </div>
        </div>
        </div>
    </div>
</template>
<script>
	import tollHint from '../TollHint/TollHint.vue'
	import toast from '../toast/Toast.vue'
    import QRCode from 'qrcodejs2'
    import NoPay from './../noPay'
    import User from '../user.js' //引用模块进来
    import {initCyComment} from '../ChangYanComment.js'

    export default({
		name: 'consultArticle',
        props:['author', 'description', 'advice','spacecontent','typey',"myclickToggle"],
		data: function() {
			return {
                loadShow:true,
				checkpay: '',
				probationes: [],
                sys_comment: false, // 是否显示评论
                cy_comment: false, // 是否使用畅言评论
                is_all_audit: false, // 是否全部审核
                comment: [],
                content: '',
                comment_total: 0,
                page:1,
                page_size:20,
                total_page: 1,
				detailes: {},
                space: {},
				bases: toast.apiUrl,
                value:'', // 循环value 默认值
                viewToggle:true,
                selfclickToggle:this.myclickToggle,
                out_trade_no: '',
                timer: null,
                showDetail: this.$route.params.contentid
			}
		},
		created: function() {
            this.viewToggle=this.IsPC();
		    if (this.$route.params.contentid != 0) {
                let that = this;
                this.$axios.post('/api/pc/getarticledetail', {
                    id: this.$route.params.contentid,
                    author: this.author
                }).then(response => {
                    if(response.data.state) {
                        this.loadShow=false;
                        that.detailes = response.data.data;
                        that.space = response.data.data.space;
                        this.statistics();
                    } else {
                        this.loadShow=false;
                        $(".wrap").text(response.data.error);
                        $(".wrap").show().delay(1500).hide(100);
                    }

                },function (error) {
                    this.loadShow=false;
                })

                this.getComment();

                this.$nextTick (function () {
                    this.qrcode()
                })
            }
		},
		mounted() {
			this.load();
		},
		methods: {
            goback(){
                if(this.selfclickToggle){
                    this.$router.push({name:'consult_particulars_organization',params :{id:"10",type:1}})
                }else{
                    this.$parent.clickTogglesTrue();
                }
            },
            // 详情跳转
            Torouter(item) {
                this.$router.push({name:'consultdetails',params :{name:item,contentid:0}})
            },
            gotoPage(num) {

                this.$router.push({name:'consult_particulars_organization',params :{id:"10",type:num}})
            },
            digg(){
                this.$axios.post('/api/pc/articledigg', {
                    id: this.$route.params.contentid
                }).then(response => {
                    if(response.data.state) {
                        this.detailes.isDigg=!this.detailes.isDigg;
                    } else {
                        $(".wrap").text(response.data.error);
                        $(".wrap").show().delay(1500).hide(100);
                    }

                })
            },
            like(){
                this.$axios.post('/api/pc/collectcontent', {
                    id: this.$route.params.contentid
                }).then(response => {
                    if(response.data.state) {
                        this.detailes.isCollect=!this.detailes.isCollect;
                    } else {
                        $(".wrap").text(response.data.error);
                        $(".wrap").show().delay(1500).hide(100);
                    }

                })
            },
            sendComment(){
                if (!this.content) {
                    $(".wrap").text('Comments should not be empty');
                    $(".wrap").show().delay(1500).hide(100);
                    return;
                }
                this.$axios.post('/api/pc/commentreply', {
                    content_id: this.$route.params.contentid,
                    appid: this.detailes.appid,
                    reply_id: 0,
                    content: this.content

                }).then(response => {
                    if(response.data.state) {
                        this.content = '';
                        this.getComment();
                        if (this.is_all_audit) {
                            $(".wrap").text('The comments you submitted have been successful. Please wait for the administrator to review them.');
                            $(".wrap").show().delay(1500).hide(100);
                        }
                    } else {
                        $(".wrap").text(response.data.error);
                        $(".wrap").show().delay(1500).hide(100);
                    }

                })

            },
            getComment(){
                var that = this;
                this.$axios.post('/api/pc/commentlist', {
                    content_id: this.$route.params.contentid,
                    page:this.page,
                    pagesize:this.page_size
                }).then(response => {
                    if(response.data.state) {
                        that.comment=response.data.data.data;
                        that.comment_total = response.data.data.cmt_sum;
                        that.sys_comment = response.data.data.system_comment_status;
                        that.is_all_audit = response.data.data.is_all_audit;

                        if (response.data.data.cy_comment_status) {
                            that.cy_comment = true;
                            initCyComment(response.data.data.cy_comment_status.cyanCommentsCyappid, response.data.data.cy_comment_status.cyanCommentsCyappkey)
                        }
                    } else {
                        $(".wrap").text(response.data.error);
                        $(".wrap").show().delay(1500).hide(100);
                    }

                })

            },
            timeDiff(published) {
                var now = new Date();
                var date3 = now.getTime() - (published * 1000);

                // 计算相差年数
                var years =  Math.floor(date3 / (356 * 24 * 3600 * 1000))
                var mouths = Math.floor(date3 / (30 * 24 * 3600 * 1000))
                //计算出相差天数
                var days = Math.floor(date3 / (24 * 3600 * 1000))
                //计算出小时数
                var hours = Math.floor(date3 / (3600 * 1000))
                //计算相差分钟数
                var minutes = Math.floor(date3 / (60 * 1000))
                // 计算相差秒数
                var seconds = Math.floor(date3 / 1000)

                if (years > 0) {
                    if(years==1){
                        return years + 'year ago';
                    }
                    return years + 'years ago';
                }

                if(mouths > 0) {
                    if(mouths==1){
                        return mouths + 'month ago';
                    }
                    return mouths + 'months ago';
                }

                if (days > 0) {
                    if(days==1){
                        return days + 'day ago';
                    }
                    return days + 'days ago';
                }

                if(hours > 0) {
                    if(hours==1){
                        return hours + 'hour ago';
                    }
                    return hours + 'hours ago';
                }

                if(minutes > 0) {
                    if(minutes==1){
                        return minutes + 'minute ago';
                    }
                    return minutes + 'minutes ago';
                }
                if (seconds > 0) {
                    if(seconds==1){
                        return  seconds + 'second ago';
                    }
                    return  seconds + 'seconds ago';
                }
            },
			checkpays:function(index){
	            if (this.checkpay != index) {
                    this.checkpay=index;
                    this.pay();
                }

	        },
            qrcode () {
                document.getElementById("qrcode").innerHTML = "";
                let qrcode = new QRCode('qrcode', {
                    width: 100,
                    height: 100, // 高度  [图片上传失败...(image-9ad77b-1525851843730)]
                    text:  window.location.href// 二维码内容
                    // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                    // background: '#f0f'
                    // foreground: '#ff0'
                })


            },
            pay:function() {
			    var self = this;
                this.$axios.post('/api/pc/pay', {
                    order_type : 'article',
                    pay_type : this.checkpay,
                    product_id : this.$route.params.contentid,
                    origin_url : window.location.href
                }).then(response => {
                    if (this.checkpay == 'alipay') {
                        if (response.data.state) {
                            $('#buyModal').append(response.data.data.content);
                        }
                    }
                    // 微信支付需要查询订单状态
                    if (this.checkpay == 'wechat' ) {
                        if (response.data.state) {
                             self.out_trade_no = response.data.data.out_trade_no;
                             document.getElementById("payQrcode").innerHTML = "";
                             new QRCode('payQrcode', {
                                width: 150,
                                height: 150, // 高度  [图片上传失败...
                                text:  response.data.data.content// 二维码内容
                                // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                                // background: '#f0f'
                                // foreground: '#ff0'
                            })
                            // 两秒之后执行轮训
                            setTimeout(this.checkPayResult, 2000);
                        }
                    }

                })
            },
            // 检查订单状态
            checkPayResult:function() {
                clearInterval(this.timer);
                if(this.checkpay == 'wechat') {
                    this.timer = setInterval(() => {
                        this.$axios.post('/api/pc/payresult', {
                            out_trade_no : this.out_trade_no
                        }).then(response => {
                            if (response.data.data.state == 6) {
                                $(".wrap").text('Successful payment！');
                                $(".wrap").show().delay(1500).hide(100);
                                clearInterval(this.timer);
                                // 关闭弹框
                                $('#buyModal').modal('hide')

                                // 重新获取右侧文章
                                let that = this;
                                this.$axios.post('/api/pc/getarticledetail', {
                                    id: this.$route.params.contentid
                                }).then(response => {
                                    if(response.data.state) {
                                        this.$parent.clickToggles();
                                        that.detailes = response.data.data;
                                        if(window.screen.width < 500 && window.screen.height < 800){
                                            document.querySelector("#centre_contents").scrollIntoView(true);
                                        }

                                    } else {
                                        this.selfclickToggle=false;
                                        $(".wrap").text(response.data.error);
                                        $(".wrap").show().delay(1500).hide(100);
                                    }

                                })
                            }
                        })

                    },1000);
                }
            },
            // 统计
            statistics:function(){
                document.getElementById('staticData').remove();
                var s = document.createElement("script");
                s.type = "text/javascript";
                s.id = 'staticData';
                s.innerHTML = "_paq.push(['eventBrowse', "+this.detailes.id+", {'title': '"+this.detailes.title+"','catName': '"+this.detailes.category_name+"'}, 1]);_paq.push(['eventCustom', 'CAT', {'catName': '"+this.detailes.category_name+"'}, 1]);_paq.push(['trackPageView']);";
                document.getElementsByTagName("head")[0].appendChild(s);
            }
        },
		watch: {
			$route: {
				handler: function(val, oldVal) {
                    this.showDetail = this.$route.params.contentid;
				    if (this.$route.params.contentid == 0) {
                        return;
                    }

					let that = this;
					this.$axios.post('/api/pc/getarticledetail', {
						id: this.$route.params.contentid,
                        author:this.author
					}).then(response => {
						if(response.data.state) {
                            if(val.path.indexOf(oldVal.path)<0){
                                that.$parent.clickToggles();
                            }
							that.detailes = response.data.data;
							that.space = response.data.data.space;
                            this.qrcode()
                            this.getComment()
                            this.statistics()
                            if(window.screen.width < 500 && window.screen.height < 800){
                                document.querySelector("#centre_contents").scrollIntoView(true);
                            }

						} else {
                            this.selfclickToggle=false;
							$(".wrap").text(response.data.error);
							$(".wrap").show().delay(1500).hide(100);
						}

					})

				},
				deep: true
			}
		},
		components: {
			tollHint,
			toast,
            NoPay
		}
	})
</script>
<style type="text/css">
    .information_article_details img{
        display: block;
        max-width: 100%;
        margin: 0 auto;
    }
    .information_article_details video{
        display: block;
        max-width: 100%;
        margin: 0 auto;
    }

</style>
<style scoped>
    /*评论start*/
    .lists{
        padding:0
    }
    .lists li{
        padding:30px 0;
        display:flex;
        justify-content:flex-start;
        border-bottom:1px solid #EBEBEB;
    }
    .lists li img{
        width:48px;
        height:48px;
        border-radius:50%;
        margin-right:17px;
        vertical-align:middle;
    }
    .lists li div p:nth-child(1) span:nth-child(1){
        font-size:14px;
        font-family:PingFangSC-Medium;
        font-weight:600;
        margin-right:30px;
        color:rgba(38,38,38,1);
        line-height:20px;
    }
    .lists li div p:nth-child(1) span:nth-child(2){
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(89,89,89,1);
        line-height:17px;
    }
    .lists li div p:nth-child(2){
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(89,89,89,1);
        line-height:20px;
        margin-bottom: 0;
    }
    .listTotal{
        margin-top:20px;
    }
    .totalT{
        font-size:15px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(38,38,38,1);
        line-height:21px;
    }
    .totalNum{
        font-size:15px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(153,153,153,1);
        line-height:21px;
    }
    .commentList{
        border:none;
        margin-left:-24px;
        margin-right:-24px;
        border-bottom:1px solid #EBEBEB
    }
    .comment{
        text-align:right;
    }
    .comment button{
        width:100px;
        height:36px;
        background:rgba(32,142,255,1);
        border-radius:2px;
        font-size:15px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:15px;
        text-align:center;
    }
    .mybtns{
        background:rgba(255,255,255,1);
        border-radius:16px;
        border:1px solid rgba(32,142,255,1);
        color:rgba(32,142,255,1);
    }
    .M-block{
        height:15px;
        background-color:#F5F6F7;
        margin-left:-24px;
        margin-right:-24px;
    }
    /*评论end*/
    .myBtn{
        width:60px;
        height:30px;
        display:block;
        position:absolute;
        top:20px;
        right:20px;
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        line-height:30px;
        text-align:center;
        background:rgba(242,243,244,1);
        border-radius:20px;
    }
    .myBtn:hover{
        cursor:pointer;
    }
    #consult_left_content{
        height: 65px;
    }
    .modal-dialog{
        max-width: 600px;
    }
    .card-subtitle{
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        line-height:20px;
    }
    .kaitong{
        background-color: #FEB133;
        border-color: #FEB133;
    }
    .mycard{
        padding-bottom:110px!important;
    }
    .myfix{
        position: absolute;
        bottom: 0;
        left: 0;
        padding-top:10px;
        background:rgba(255,255,255,1);
        box-shadow:0px -2px 5px 0px rgba(0,0,0,0.05);
    }
    .desp{
        overflow:hidden;
        text-overflow:ellipsis;
        margin-bottom: 22px;
        white-space:nowrap;
        font-size:13px;
        height:30px;
        max-width: 400px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        line-height:30px;
    }
    .myfont{
        margin-bottom: 0;
    }
    .mcur{
        line-height: 18px;
    }
    .abc{
        display: flex;
        justify-content: space-between;
    }
    @media screen and (max-width: 600px){
        #consult_left_content{
            height:50px;
        }
        .myfix{
            position: fixed;
        }
        .abc{
            display: block!important;
            text-align: center;
        }
        .abc>div{
            width:auto;
            margin-top: 15px;
        }
        .mycard>h5{
            margin-top:10px!important;
        }
        .mybtn:nth-child(1){
            margin-right:0!important;
        }
        .card-body{
            padding:.5rem 0;
        }
        .desp{
            margin-bottom: 10px;
        }
        .mt-40{
            margin-top: 30px;
        }
        .aaas{
            display: block;
        }
        .myfont{
            height: auto;
        }
    }
</style>
